export const sliderItems = [
   
   
    {
      id: 1,
      img: "https://i.ibb.co/PTN6740/5903b4516c69b12c9addbdcead3f6bc3-removebg-preview.jpg",
      title: "WINTER COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#ffffe0",
       productid:"62df07065415fcd13eea3511"
    },

     {
      id: 2,
      img: "https://i.ibb.co/1sgS5Vf/Pima-Polo-Blue-3-a68207d8-ce3f-420d-9afb-605ec14ff3cd-540x-removebg-preview.jpg",
      title: "SUMMER COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#fcf1ed",
      productid:"62dec5cd5415fcd13eea34bb"
    },
    
    {
      id: 3,
      img: "https://i.ibb.co/tcRYS36/8a6b755083e7bf18d4613c4d29eff3da-removebg-preview-1.jpg",
      title: "COOL GADGETS",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#ffebeb",
      productid:"62dfd89bc02530b1ad36dbf1"
    },
    {
      id: 4,
      img: "https://i.ibb.co/wKztC7d/41-WZg-Ht4o-GL-removebg-preview.jpg",
      title: "KIDS COLLECTION",
      desc: "DON'T COMPROMISE ON STYLE! GET FLAT 30% OFF FOR NEW ARRIVALS.",
      bg: "#fbf0f4",
      productid:"62e01758c02530b1ad36dc35"
    },
  ];

  export const categories = [
    {
      id: 1,
      img: "https://i.ibb.co/PwmWF9Q/wepik-photo-mode-2022627-0132.png",
      title: "Men Fashion",
      cat:"men",
      color:"black"
    },
    {
      id: 2,
      img: "https://img.freepik.com/free-photo/fashionable-pale-brunette-long-green-dress-black-jacket-sunglasses-standing-street-during-daytime-against-wall-light-city-building_197531-24468.jpg?w=740&t=st=1658855708~exp=1658856308~hmac=4700b7893ee94312d363d21b5b1febc2e511445ff39369bfad2d095322eb49c0",
      title: "Women Fashion",
      cat:"women",
      color:"white"
    },

     {
      id: 3,
      img: "https://i.ibb.co/D7pQzsc/stylish-modern-woman-headphones-listening-music-dancing-enjoying-favorite-songs-earphones-standing-a.jpg",
      title: "Electronics",
      cat:"electronics",
      color:"black"
    },
    
    {
      id: 4,
      img: "https://cdn2.momjunction.com/wp-content/uploads/2016/02/Kids-Modeling-Can-Your-Kid-Be-A-Model-And-How.jpg",
      title: "Kids Fashion",
      cat:"kids",
      color:"white"
    },
    
  ];

  export const popularProducts = [
    {
      id:1,
      img:"https://i.ibb.co/ZVn0k7t/1657002849-AVM0110.jpg",
      productId:"62deb8f35415fcd13eea34b3"
    },
    {
      id:2,
      img:"https://i.ibb.co/TrnLLnF/61-PJd-Tgg-I7-L-UX679.jpg",
      productId:"62dec39f5415fcd13eea34b9"
    },
    {
      id:3,
      img:"https://i.ibb.co/ykSrwHv/817a-VWYpbl-L-SY450.jpg",
      productId:"62e00149c02530b1ad36dc15"

    },
    {
      id:4,
      img:"https://i.ibb.co/D4jvGCK/s-l500.jpg",
      productId:"62dfb963c02530b1ad36dbce"
    },
    {
      id:5,
      img:"https://i.ibb.co/PMPNjB7/shopping-3.png",
      productId:"62e00d9cc02530b1ad36dc24"
    },
    {
      id:6,
      img:"https://m.media-amazon.com/images/I/61RJWO736fL._UX679_.jpg",
      productId:"62e016efc02530b1ad36dc32"
    },
    {
      id:7,
      img:"https://i.ibb.co/6YvG0NV/61u-LNy-B9-En-L-AC-UX522.jpg",
      productId:"62decc6f5415fcd13eea34c1"
    },
    {
      id:8,
      img:"https://i.ibb.co/6XcGrtW/51o-T2-SIR-v-L-UY741.jpg",
      productId:"62def8365415fcd13eea3506"
    },
  ]